module.exports = __webpack_public_path__ + "static/img/bg-id.9e5b83a5.png";